import { render, staticRenderFns } from "./fan-form-page.vue?vue&type=template&id=4d347a44&"
import script from "./fan-form-page.vue?vue&type=script&lang=js&"
export * from "./fan-form-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports